import { Colors } from '@/shared/entities/types';
import React from 'react';
import { Icon, Text } from 'vkit/lib/components';
import { Grid } from 'vkit/lib/context';

interface CardMessageProps {
  icon?: string;
  message?: string;
  color?: Colors;
  height?: number | string;
  width?: number | string;
  padding?: number | string;
}

export const CardMessage: React.FC<CardMessageProps> = ({
  message,
  icon,
  color = 'colorDefault',
  height,
  width,
  padding = 12,
}) => {
  const colorStyle: Record<Colors, { border: string; background: string }> = {
    danger: {
      background: 'rgba(255, 65, 58, 0.15)',
      border: 'var(--vkit-color-danger)',
    },
    info: {
      background: 'rgba(41, 215, 242, 0.15)',
      border: 'var(--vkit-color-info)',
    },
    light: {
      background: 'rgba(137, 151, 166, 0.15)',
      border: 'var(--vkit-color-light)',
    },
    success: {
      background: 'rgba(147, 201, 10, 0.15)',
      border: 'var(--vkit-color-success)',
    },
    warning: {
      background: 'rgba(236, 170, 0, 0.15)',
      border: 'var(--vkit-color-warning)',
    },
    colorDefault: {
      background: 'rgba(0, 123, 255, 0.1)',
      border: 'var(--vkit-color-colorDefault)',
    },
  };

  return (
    <div
      data-testid='card-message'
      style={{
        border: '1px solid',
        borderColor: colorStyle[color].border,
        background: colorStyle[color].background,
        borderRadius: 5,
        padding,
        height,
        width,
      }}>
      <Grid gap={8} alignItems='center'>
        {icon && <Icon name={icon} size={24} color={color} />}
        {message && <Text color={color} value={message} size='medium' />}
      </Grid>
    </div>
  );
};
